<template>
  <form ref="form">
    <v-file-input
      label="Fisier XLS(X)"
      ref="fileField"
      @change="fileAdded"
      persistent-hint
      hint="Celula marcata cu # semnaleaza randul ce contine capetele de tabel. Urmatoarele randuri se vor considera a fi date.">
    </v-file-input>
  </form>
</template>

<script>
import tableHeaders from '@/mixins/tableHeaders'
import Worker from '@/workers/fileReader.worker.js'

export default {
  name: 'avz-users',
  mixins: [tableHeaders],
  methods: {
    async fileAdded ($event) {
      const json = await readFile($event)
      const headers = json.splice(0, 1)
      headers[0].pop()
      const items = json.map(row => {
        const obj = {}
        headers[0].forEach((head, index) => {
          console.log(head, index)
          obj[head] = row[index]
        })
        return obj
      })
      console.log(items)
    }
  }
}

function readFile (file) {
  return new Promise((resolve, reject) => {
    const worker = new Worker()
    worker.onmessage = e => {
      worker.terminate()
      resolve(e.data.result)
    }

    worker.postMessage({ message: 'readFile', file })
  })
}
</script>
